import React from 'react';
import { Users, Target, ChartBar, FileCheck, Flag, CarFront, Car, Hotel, Building, Construction, Banknote } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Badge } from "@/components/ui/badge";

const team = [{
  name: "Hussein Fawzi",
  role: "CEO - Partner",
  img: "/lovable-uploads/325dbc11-b85f-4bbd-ac2b-23905415c5de.png",
  description: "Tech founder and operator; built Mexico's #2 largest restaurant VMS via an M&A roll-up."
}, {
  name: "Ronni Samir",
  role: "CIO - Partner",
  img: "/lovable-uploads/062e011a-6054-4e22-9bb8-3ef795f23d6e.png",
  description: "ETA with +10 years experience acquiring and building B2B Saas companies across LatAm."
}, {
  name: "Ignacio Lizarraga",
  role: "CFO",
  img: "/lovable-uploads/d67412b2-4dac-4f70-a82a-3c39286ebeaf.png",
  description: "Investor with 10+ years in M&A, private equity, and search funds across LatAm."
}];

const criteria = ["$2-10M USD ARR", "90%+ customer retention", "+20% EBITDA margins", "Industry / vertically focused", "Mission critical solutions", "High market share"];

const metrics = [{
  number: "5K+",
  label: "Total Market Size",
  tag: "LatAm"
}, {
  number: "1,300",
  label: "Initial Pipeline",
  tag: "Mexico"
}, {
  number: "35",
  label: "Active Discussions",
  tag: "Mexico"
}, {
  number: "7",
  label: "Active Deals",
  tag: "Mexico"
}];

const deals = [{
  company: "Project Mustang",
  status: "",
  arr: "$4.5M USD",
  ebitda: "$1,5M USD",
  price: "5x + earn-out",
  description: "Dealership Management Software (DMS) for OEM car dealerships in Mexico.",
  logo: <CarFront className="w-5 h-5 text-blue-500" />
}, {
  company: "Project Phoenix",
  status: "",
  arr: "$5.5M USD",
  ebitda: "$3M USD",
  price: "5x + earn-out",
  description: "Enterprise Resource Planner (ERP) for hotels in Mexico.",
  logo: <Hotel className="w-5 h-5 text-blue-500" />
}, {
  company: "Project Heron",
  status: "",
  arr: "$3M USD",
  ebitda: "$1M USD",
  price: "5x + earn-out",
  description: "Core banking software for banks and financial institutions in Mexico.",
  logo: <Banknote className="w-5 h-5 text-blue-500" />
}, {
  company: "Project Condor",
  status: "",
  arr: "$9M USD",
  ebitda: "$2,5M USD",
  price: "6x + earn-out",
  description: "Enterprise Resource Planner (ERP) for construction companies in Mexico.",
  logo: <Construction className="w-5 h-5 text-blue-500" />
}];

const TeaserPage = () => {
  return <div className="min-h-[297mm] w-[210mm] mx-auto bg-white text-noa-rich-black relative">
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-br from-[#0D1F2D] to-[#1a2c3b] z-10">
        {/* Reduced banner height from h-52 to h-32 */}
      </div>
      
      <div className="px-8 py-6 relative z-20">
        <div className="text-left mb-8">
          <div className="relative inline-block">
            <h1 className="font-space-grotesk text-lg sm:text-xl lg:text-2xl font-bold leading-tight mb-2 text-white">
              <span className="text-white">
                Latin America
              </span>
            </h1>
            <h2 className="font-space-grotesk text-lg sm:text-xl lg:text-2xl font-bold text-gray-500">
              VMS Serial Acquisitions HoldCo
            </h2>
            <div className="absolute -left-4 -right-4 top-1/2 -translate-y-1/2 h-[100%] bg-gradient-to-r from-blue-500/0 via-blue-500/5 to-blue-500/0 -z-10 rounded-full blur-xl"></div>
          </div>
        </div>

        <div className="mb-12 mt-16">
          <div className="grid grid-cols-3 gap-4">
            {team.map((member, index) => <div key={index} className="bg-white shadow-lg rounded-lg p-4 hover:shadow-xl transition-shadow h-full">
                <div className="w-32 h-32 mx-auto mb-3 rounded-full overflow-hidden flex-shrink-0">
                  <img src={member.img} alt={member.name} className="w-full h-full object-cover object-center" style={{
                objectPosition: member.name === "Hussein Fawzi" ? "center 20%" : member.name === "Ronni Samir" ? "center 15%" : "center"
              }} />
                </div>
                <div className="text-center">
                  <h3 className="text-base font-bold mb-1">{member.name}</h3>
                  <p className="text-noa-paynes-gray mb-1 text-sm">{member.role}</p>
                  <p className="text-xs text-noa-charcoal leading-tight">{member.description}</p>
                </div>
              </div>)}
          </div>
        </div>

        <section className="py-8 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <Target className="w-5 h-5 text-noa-paynes-gray" />
              <h2 className="text-xl font-bold">VMS Investment Criteria</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {criteria.map((item, index) => <div key={index} className="bg-noa-antiflash-white rounded-lg p-2 hover:bg-noa-antiflash-white/80 transition-colors text-sm">
                  <p>{item}</p>
                </div>)}
            </div>
          </div>
        </section>

        <section className="py-8 px-4 bg-noa-antiflash-white/50">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <ChartBar className="w-5 h-5 text-noa-paynes-gray" />
              <h2 className="text-xl font-bold">VMS Market Opportunity</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {metrics.map((metric, index) => (
                <div key={index} className="bg-white shadow-md rounded-lg p-4 text-center hover:shadow-lg transition-shadow relative">
                  {metric.tag && (
                    <Badge variant="secondary" className="absolute right-[-8px] top-[-8px] text-xs bg-noa-rich-black/90 text-white">
                      {metric.tag === "Mexico" && <Flag className="w-3 h-3 mr-1" />}
                      {metric.tag}
                    </Badge>
                  )}
                  <div className="flex flex-col items-center justify-center mb-2">
                    <h3 className="text-2xl font-bold text-noa-paynes-gray">{metric.number}</h3>
                    <p className="text-sm text-noa-charcoal">{metric.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="bg-noa-antiflash-white rounded-lg p-8 mb-12 shadow-lg">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-noa-rich-black mb-2">Highlighted Active Deals</h2>
            <p className="text-noa-paynes-gray">Latest opportunities in our pipeline</p>
          </div>
          <div className="grid grid-cols-2 gap-6">
            {deals.map((deal, index) => <div key={index} className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100 relative">
                <div className="flex justify-between items-center mb-4">
                  <div className="flex items-center gap-2">
                    <h3 className="text-xl font-bold text-noa-rich-black">{deal.company}</h3>
                    {deal.logo && <div>{deal.logo}</div>}
                  </div>
                  {deal.status && <span className="px-3 py-1 bg-noa-antiflash-white text-noa-paynes-gray rounded-full text-sm">
                    {deal.status}
                  </span>}
                </div>
                {deal.description && <p className="text-noa-charcoal text-sm mb-4 italic">{deal.description}</p>}
                <div className="space-y-2">
                  <p className="text-noa-charcoal"><strong>ARR:</strong> {deal.arr}</p>
                  <p className="text-noa-charcoal"><strong>EBITDA:</strong> {deal.ebitda}</p>
                  {deal.price && <p className="text-noa-charcoal"><strong>Price:</strong> {deal.price}</p>}
                </div>
              </div>)}
          </div>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="relative mb-8 text-center">
            <Badge variant="secondary" className="inline-block mb-2 bg-green-500 text-white">
              Under Exclusivity & DD
            </Badge>
            <h2 className="text-2xl font-bold text-noa-rich-black mb-2">
              Our Most Advanced Deal
            </h2>
          </div>
          <p className="text-noa-charcoal text-lg mb-4 -mt-1 text-center">
            Project Mustang — a Dealership Management Software (DMS) with 33% market share in Mexico's OEM car dealership market, with over 20 years in the industry.
          </p>
          <div className="rounded-lg overflow-hidden shadow-lg">
            <img src="/lovable-uploads/cdda8ca3-de41-4638-8aa3-697a897e0e59.png" alt="Project Mustang Overview" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </div>;
};

export default TeaserPage;
